export const BIRTHDAYS_LIST_THIS_YEAR = 'BIRTHDAYS_LIST_THIS_YEAR'
export const BIRTHDAYS_LIST_THIS_YEAR_SUCCESS = 'BIRTHDAYS_LIST_THIS_YEAR_SUCCESS'
export const BIRTHDAYS_LIST_THIS_YEAR_FAILED = 'BIRTHDAYS_LIST_THIS_YEAR_FAILED'
export const BIRTHDAYS_LIST_NEXT_YEAR = 'BIRTHDAYS_LIST_NEXT_YEAR'
export const BIRTHDAYS_LIST_NEXT_YEAR_SUCCESS = 'BIRTHDAYS_LIST_NEXT_YEAR_SUCCESS'
export const BIRTHDAYS_LIST_NEXT_YEAR_FAILED = 'BIRTHDAYS_LIST_NEXT_YEAR_FAILED'
export const CLEAR_BIRTHDAYS_LIST = 'CLEAR_BIRTHDAYS_LIST'
